import React from "react";
import { useDispatch } from "react-redux";
import { IoClose } from "react-icons/io5";
import { decreaseQty, deleteItem, increaseQty } from "../redux/shopSlice";
import { toast, ToastContainer } from "react-toastify";



function CartItem(cart) {
  const dispatch = useDispatch();/* 
  const productData = useSelector((state) => state.shopsyReducer.productData); */
  
  const userCart = cart.items? cart.items : []
  console.log('Final : ', userCart);
  
  return (
    <div className="">
      <div className="w-full">
        {/* <h2 className="font-semibold font-bodyFold text-2xl text-center bg-slate-300 text-slate-800 w-2/4 rounded-lg py-1 mx-auto">SHOPING CART</h2> */}
        <div className="pb-6">
          { userCart.map((item) => (
            
            <div
              key={item.productId}
              className="flex justify-between gap-6 mt-5 w-full  h-4/6  bg-slate-300 py-3 px-4 mx-auto rounded-xl"
            >
              <div className="flex flex-col gap-2">
                {/* </div><IoClose className="text-xl text-slate-800 hover:text-red-800 duration-300 cursor-pointer" />
                
                            <div > */}

                <img
                  src={item.image}
                  alt="item_image"
                  className="w-28 h-28 md:h-32 hover:object-cover object-fill duration-500 rounded-lg border-slate-400 border-2"
                />

                <div className="w-18 justify-between items-center bg-slate-800  text-slate-200 gap-3 border rounded-xl border-gray-800 p-1">
                  <div className="flex items-center justify-between gap-2 text-sm font-semibold px-1 group">
                    <button
                      className="border border-slate-700 h-5 font-normal text-xl flex items-center justify-center px-2 py-2 active:scale-y-150
                            hover:bg-slate-800  hover:text-slate-100 cursor-pointer duration-300 active:bg-purple-500 rounded-md"
                      onClick={() =>
                        dispatch(
                          decreaseQty({
                            _id: item.productId,
                          })
                        )
                      }
                    >
                      -
                    </button>
                    <span className="border rounded-md border-slate-600 p-1 px-2 bg-slate-700 font-semibold group-active:scale-50 active:font-bold duration-200">
                      {item.quantity}
                    </span>
                    <button
                      onClick={() =>
                        dispatch(
                          increaseQty({
                            _id: item.productId,
                          })
                        )
                      }
                      className="border border-slate-700 h-5 font-normal text-lg flex items-center justify-center px-2 py-2 active:scale-y-150
                            hover:bg-slate-800 hover:text-slate-100 cursor-pointer duration-300 active:bg-purple-500 rounded-md"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>

              {/* <h2 className='flex flex-col w-1/2'>{item.title.substring(0,18)}</h2> */}
              <div className="py-3">
                {/* */}
                <h2 className="w-40">{item.title.substring(0, 50)}</h2>
                <p className="w-40 font-semibold font-bodyFont pt-3 text-slate-600 text-sm">
                  <span className="font-medium">Price : </span>
                  {item.price}&pi;
                </p>
                <p className="w-40 font-bold text-lg font-bodyFont pt-2 text-purple-800">
                  <span className="font-medium text-base text-gray-900">
                    Total :{" "}
                  </span>
                  {(item.price * item.quantity).toFixed(3)}&pi;
                </p>
              </div>
              <div className="bg-slate-300 flex rounded-lg justify-end">
                <button
                  onClick={() =>
                    dispatch(deleteItem({ _id: item.productId})) &
                    toast.error(`${item.title} is Removed from your cart.`)
                  }
                  className="mt-auto bg-slate-800 p-1 rounded-lg "
                >
                  <IoClose className="text-xl text-red-400 duration-300 cursor-pointer" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ToastContainer
        position="top-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName="custom-toast-background"
      />
    </div>
  );
}

export default CartItem;
